export default __webpack_public_path__ + "static/media/check.227f908c.svg";